import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import PublicNav from '../components/public/PublicNav';
import PublicFooter from '../components/public/PublicFooter';
import { useContactInfo, textLines } from '../lib/publicContent';
import { ed, usePageMeta } from '../lib/editTexts';
import '../styles/public.css';

export default function SupportPage() {
  const { t } = useTranslation();
  const { location, email } = useContactInfo();
  usePageMeta('support');
  // Impressum: Anschrift aus AgoraHub-Kontakt, ausser legal.imprint.address ist gepflegt; Register/Verantwortlich nur wenn gepflegt.
  const address = textLines(t('legal.imprint.address'));
  const register = t('legal.imprint.register');
  const responsible = textLines(t('legal.imprint.responsible'));

  const cards = [
    { n: '01', id: 'contact', href: 'mailto:marcus.dolak@agorahub.de?subject=KAC%20Berlin%20Support' },
    { n: '02', id: 'privacy', to: '/privacy' },
    { n: '03', id: 'help', href: `mailto:info@kacberlin.com?subject=${encodeURIComponent(t('support.help.mail_subject'))}` },
  ];

  return (
    <div className="kac-public">
      <div className="kac-inner">
        <PublicNav />

        {/* HERO */}
        <div className="kac-hero">
          <div className="kp-kicker" style={{ marginBottom: 12 }} {...ed('support.eyebrow')}>{t('support.eyebrow')}</div>
          <h1 {...ed('support.title')} style={{ fontFamily: "'Bricolage Grotesque',sans-serif", fontWeight: 700, fontSize: 78, lineHeight: 0.95, margin: '0 0 24px' }}>
            {t('support.title')}
          </h1>
          <p {...ed('support.description')} style={{ fontSize: 19, lineHeight: 1.65, color: '#5e554b', maxWidth: 600, margin: 0 }}>
            {t('support.description')}
          </p>
        </div>

        {/* CARDS */}
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2,1fr)', gap: 24, padding: '0 4px 0' }}>
          {cards.map(c => (
            <div key={c.n} className="kac-card" style={{ padding: '36px 32px', display: 'flex', flexDirection: 'column' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 20 }}>
                <span style={{ fontFamily: "'Bricolage Grotesque',sans-serif", fontWeight: 700, fontSize: 18, color: '#C2B6A4' }}>{c.n}</span>
                <span {...ed(`support.${c.id}.tag`)} style={{ fontSize: 10, fontWeight: 700, letterSpacing: '0.1em', textTransform: 'uppercase', color: '#C0291F', background: '#F1EADB', padding: '4px 10px', borderRadius: 999 }}>{t(`support.${c.id}.tag`)}</span>
              </div>
              <h3 {...ed(`support.${c.id}.title`)} style={{ fontFamily: "'Bricolage Grotesque',sans-serif", fontWeight: 700, fontSize: 22, margin: '0 0 12px' }}>{t(`support.${c.id}.title`)}</h3>
              <p {...ed(`support.${c.id}.description`)} style={{ fontSize: 15, lineHeight: 1.65, color: '#5e554b', margin: '0 0 28px', flex: 1 }}>{t(`support.${c.id}.description`)}</p>
              {c.to ? (
                <Link to={c.to} style={{ fontSize: 14, fontWeight: 600, color: '#C0291F', textDecoration: 'none' }}><span {...ed(`support.${c.id}.button`)}>{t(`support.${c.id}.button`)}</span> →</Link>
              ) : (
                <a href={c.href} target={c.href?.startsWith('http') ? '_blank' : undefined} rel="noopener noreferrer" style={{ fontSize: 14, fontWeight: 600, color: '#C0291F', textDecoration: 'none' }}><span {...ed(`support.${c.id}.button`)}>{t(`support.${c.id}.button`)}</span> →</a>
              )}
            </div>
          ))}

          {/* Impressum / Organisation */}
          <div className="kac-red-panel" style={{ padding: '36px 32px' }}>
            <div {...ed('support.organization.title')} style={{ fontSize: 10, fontWeight: 700, letterSpacing: '0.1em', textTransform: 'uppercase', opacity: 0.7, marginBottom: 20 }}>{t('support.organization.title')}</div>
            <h3 {...ed('support.organization.name')} style={{ fontFamily: "'Bricolage Grotesque',sans-serif", fontWeight: 700, fontSize: 20, margin: '0 0 16px', lineHeight: 1.25 }}>
              {t('support.organization.name')}
            </h3>
            <div style={{ fontSize: 14, lineHeight: 1.9, opacity: 0.88 }}>
              {address.length > 0 ? (
                <div {...ed('legal.imprint.address', 'lines')} style={{ marginBottom: 12 }}>
                  {address.map((line, i) => <div key={i}>{line}</div>)}
                </div>
              ) : location && (
                <div data-edit-central="contact_info" style={{ marginBottom: 12 }}>
                  <div>{location.addressLine1}</div>
                  <div>{location.addressLine2}, <span {...ed('support.organization.country')}>{t('support.organization.country')}</span></div>
                </div>
              )}
              <div><span {...ed('support.organization.email_label')}>{t('support.organization.email_label')}</span> <span data-edit-central="contact_info">{email}</span></div>
              <div><span {...ed('support.organization.representative_label')}>{t('support.organization.representative_label')}</span> <span {...ed('support.organization.representative_name')}>{t('support.organization.representative_name')}</span></div>
              {register && <div {...ed('legal.imprint.register')}>{register}</div>}
              {responsible.length > 0 && (
                <div style={{ marginTop: 12 }}>
                  <div style={{ opacity: 0.7 }} {...ed('support.organization.responsible_label')}>{t('support.organization.responsible_label')}</div>
                  <div {...ed('legal.imprint.responsible', 'lines')}>{responsible.map((line, i) => <div key={i}>{line}</div>)}</div>
                </div>
              )}
            </div>
          </div>
        </div>

        <PublicFooter />
      </div>
    </div>
  );
}
